import { render, staticRenderFns } from "./previewDesktop.vue?vue&type=template&id=3c4ccce3&scoped=true&"
import script from "./previewDesktop.vue?vue&type=script&lang=js&"
export * from "./previewDesktop.vue?vue&type=script&lang=js&"
import style0 from "./previewDesktop.vue?vue&type=style&index=0&id=3c4ccce3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ccce3",
  null
  
)

export default component.exports